import { useMutation, useQueryClient } from 'react-query';
import {
	createUser,
	deleteUser,
	updateUser,
} from '../../services/apis/UserApi';

const useUserMutation = () => {
	const queryClient = useQueryClient();
	return useMutation(
		({ type, data }) => {
			const mutationFn =
				type === 'add'
					? createUser
					: type === 'change'
					? updateUser
					: deleteUser;

			const result = mutationFn(data);
			return result;
		},
		{
			onSuccess: (data) => {
				console.log('useUserMutation data', data);
				queryClient.refetchQueries('users');
				queryClient.refetchQueries('profiles');
				return true;
			},
			onError: (error) => {
				console.error(error);
				return false;
			},
		},
	);
};

export default useUserMutation;
